<template>
  <div class="receiptList">
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="2" ref="BLM-search">
        <el-form-item prop="times" label="创建时间">
          <el-date-picker
            v-model="searchData.times"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="completeTime" label="实付日期">
          <el-date-picker
            v-model="searchData.completeTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="discardTime" label="作废日期">
          <el-date-picker
            v-model="searchData.discardTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="state" label="付款单状态">
          <el-select
            v-model="searchData.state"
            clearable
            placeholder="请选择付款单状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in stateList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="payType" label="付款内容">
          <el-select
            v-model="searchData.payType"
            clearable
            placeholder="请选择付款内容"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in freeTypeList"
              :label="item.name"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="carId" label="车牌号">
          <el-select
            v-model="searchData.carId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入"
            clearable
            :remote-method="
              query => {
                gerCarNoList(query)
              }
            "
            :loading="oLoading.carFuzzySearch"
            @change="value => !value && (this.carList = [])"
          >
            <el-option
              v-for="item in carList"
              :key="item.id"
              :label="item.plateNo"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="batchPaymentId" label="批量付款ID">
          <el-input
            v-number:integer
            v-model="searchData.batchPaymentId"
            placeholder="请输入批量付款ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item prop="id" label="付款单ID">
          <el-input
            v-number:integer
            v-model="searchData.id"
            placeholder="请输入付款单ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="paymentId" label="应付ID">
          <el-input
            v-number:integer
            v-model="searchData.paymentId"
            placeholder="请输入应付ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item prop="deptIdList" label="所属部门">
          <DeptSelect v-model="searchData.deptIdList" multiple :isAll="false" />
        </el-form-item>

        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              size="small"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset('search')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <export
              v-if="judgePermission('finance_payment_bill_excel')"
              :exportTemplate="exportTemplate"
              filename="付款单管理.xlsx"
              :params="getSearchParamrs()"
            >
            </export>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>

    <div
      class="operation-box"
    >
      <div>
        <p>
          当前条件下：金额：
          <span
            v-thousand-separator="currentSummary.amountTotal"
            nullTxt='--'
          ></span>
          元
        </p>
      </div>
    </div>
    <QS-common-table
      :data="dataList"
      :columns="headColumn"
      :pagination="paginationData"
      @change="paginationChange"
    ></QS-common-table>

    <!-- 作废 -->
    <dialogWrap
      v-model="oShow.complete"
      title="提示"
      width="'560px'"
      custom-class="dialog-message"
    >
      <div class="mb-20">关闭后将作废付款单，应付单需要重新付款。</div>
      <div v-if="DingTalkShow24">
        <el-form
          ref="deleteReasonform"
          :model="deleteReasonform"
          label-width="120px"
          size="small"
          :rules="deleteReasonrules"
        >
          <el-form-item label="作废备注原因：" prop="discardReason">
            <el-input
              type="textarea"
              maxlength="1000"
              v-model="deleteReasonform.discardReason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button
          :loading="oLoading.state"
          size="small"
          type="primary"
          v-submitDingTalkShow="24"
          @click="submitInvalidHandle"
          >确认</el-button
        >
      </template>
    </dialogWrap>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import {
  getPaymentOrderList,
  paymentBillCancel,
  paymentBillStatistic,
} from '@/api/financeApi'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import selectOption from '@/store/dict/selectOptionDict'
import { throttle } from '@/utils'
import { mapState } from 'vuex'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  data() {
    return {
      DingTalkShow24: false,
      deleteReasonform: { discardReason: '' }, // 作废备注原因
      deleteReasonrules: {
        discardReason: [
          { required: true, message: '请填写作废备注原因', trigger: 'blur' },
        ],
      },
      exportTemplate: 'PaymentOrder',
      carList: [], // 模糊搜索车牌号
      currentSummary: {}, // 统计
      oShow: {
        complete: false,
      },
      oLoading: {
        search: false,
        carFuzzySearch: false,
      },
      searchData: {
        id: '',
        paymentId: '',
        times: [],
        completeTime: [], // 完成日期
        discardTime: [], // 作废日期
        batchPaymentId: '',
        state: '', // 付款单状态
        payType: '', // 付款内容
        categoryCode: '', // 付款类目
        deptIdList: [],
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      dataList: [],
      headColumn: [
        {
          name: 'id',
          columnProps: {
            label: '付款单ID',
            prop: 'id',
            width: 100,
          },
          render: ({ row }) => {
            return (
              <a class="cursor-point">
                {this.judgePermission('finance_payment_bill_detail') && (
                  <span
                    class="td-canclick"
                    onClick={() => this.viewDetails(row.id)}
                  >
                    {row.id}
                  </span>
                )}
              </a>
            )
          },
        },
        {
          name: 'paymentId',
          columnProps: {
            label: '应付ID',
            prop: 'paymentId',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'payType',
          columnProps: {
            label: '付款内容',
            prop: 'payType',
          },
          getText: ({ row }) =>
            this.formatEnumeration(this.freeTypeList)[row.payType],
        },
        {
          name: 'amount',
          columnProps: {
            label: '付款金额',
            prop: 'amount',
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.amount),
        },
        {
          name: 'payeeType',
          columnProps: {
            label: '收款方类型',
            prop: 'payeeType',
            width: 100,
          },
          getText: ({ row }) => selectOption.customerTypeDict[row.payeeType],
        },
        {
          name: 'payeeName',
          columnProps: {
            label: '收款方',
            prop: 'payeeName',
            width: 160,
          },
        },
        {
          name: 'payeeId',
          columnProps: {
            label: '收款方id',
            prop: 'payeeId',
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '付款单状态',
            prop: 'state',
            width: 100,
          },
          getText: ({ row }) => selectOption.collectionStateList[row.state],
        },
        {
          name: 'batchPaymentId',
          columnProps: {
            label: '批量付款ID',
            prop: 'batchPaymentId',
            width: 100,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            label: '创建时间',
            prop: 'gmtCreate',
            width: 100,
          },
        },
        {
          name: 'completeTime',
          columnProps: {
            label: '实付日期',
            prop: 'completeTime',
            width: 100,
          },
        },
        {
          name: 'discardTime',
          columnProps: {
            label: '作废时间',
            prop: 'discardTime',
            width: 100,
          },
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const btn = []
            if (
              this.judgePermission('finance_payment_bill_cancel') &&
              Number(row.state) === 1 &&
              !row.batchPaymentId
            ) {
              btn.push({
                name: 'edit',
                label: '作废',
                action: () => this.handleInvalid(row.id),
              })
            }
            return btn
          },
        },
      ],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    // 付款单状态
    stateList() {
      return this.dictParseList(selectOption.collectionStateList)
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  mounted() {
    this.searchData.paymentId = this.$route.query.id
    this.getPaymentOrderList()
    this.paymentBillStatistic()
    this.$refs['BLM-search'].searchMoreClick()
  },
  methods: {
    // 模糊搜索获取车牌号
    async gerCarNoList(query) {
      // 开启远程搜索
      if (query.length >= 4) {
        this.oLoading.fuzzySearch = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          this.oLoading.fuzzySearch = false
          if (code === 1) {
            this.carList = data
          }
        } catch (error) {
          this.oLoading.fuzzySearch = false
        }
      }
    },
    // 统计
    paymentBillStatistic() {
      paymentBillStatistic({
        ...this.getSearchParamrs(),
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.currentSummary = data
        }
      })
    },
    resetDeleteReasonForm() {
      if (this.DingTalkShow24) {
        this.$refs?.deleteReasonform?.resetFields()
        this.deleteReasonform.discardReason = ''
      }
    },
    // 取消弹窗
    handleCancel() {
      this.oShow.complete = false
      this.resetDeleteReasonForm()
    },
    // 作废确认
    submitInvalidHandle: throttle(async function () {
      if (this.DingTalkShow24) {
        const valid = await this.$refs?.deleteReasonform?.validate()
        if (!valid) {
          this.$message.warning('请填写作废原因！')
          return
        }
      }
      const { code } = await paymentBillCancel({
        id: this.Invalid,
        discardReason: this.deleteReasonform.discardReason,
      })
      if (code !== 1) return
      this.$message.success('提交成功！')
      this.oShow.complete = false
      this.resetDeleteReasonForm()
      this.searchHandle()
    }, 1000),
    // 作废
    handleInvalid(id) {
      this.oShow.complete = true
      this.Invalid = id
    },
    // 获取请求参数
    getSearchParamrs() {
      let startDate = ''
      let endDate = ''
      let completeStartDate = ''
      let completeEndDate = ''
      let discardStartDate = ''
      let discardEndDate = ''
      if (this.searchData.times && this.searchData.times.length) {
        startDate = this.searchData.times[0]
        endDate = this.searchData.times[1]
      }
      if (this.searchData.completeTime && this.searchData.completeTime.length) {
        completeStartDate = this.searchData.completeTime[0]
        completeEndDate = this.searchData.completeTime[1]
      }

      if (this.searchData.discardTime && this.searchData.discardTime.length) {
        discardStartDate = this.searchData.discardTime[0]
        discardEndDate = this.searchData.discardTime[1]
      }

      return {
        ...this.searchData,
        startDate,
        endDate,
        completeStartDate,
        completeEndDate,
        discardStartDate,
        discardEndDate,
      }
    },
    // 请求列表
    async getPaymentOrderList() {
      this.oLoading.search = true
      try {
        const { code, data } = await getPaymentOrderList({
          ...this.getSearchParamrs(),
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        })
        this.oLoading.search = false
        if (code === 1) {
          this.dataList = data.items
          this.paginationData.total = data.totalNum
        }
      } catch (error) {
        this.oLoading.search = false
      }
    },
    // 搜索
    searchHandle() {
      this.paginationChange({
        pagination: { pageSize: this.paginationData.pageSize, pageNum: 1 },
      })
    },
    // 查看详情弹窗
    viewDetails(id) {
      this.$router.push({
        path: '/finance/payList/detail',
        query: { id },
      })
    },
    reset(from) {
      this.$refs[from].resetFields()
      this.searchData.paymentId = ''
      this.paginationChange({ pagination: { pageSize: 10, pageNum: 1 } })
      this.carList = []
    },
    // 分页事件
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getPaymentOrderList()
      this.paymentBillStatistic()
    },
  },
}
</script>

<style scoped lang="scss">
.search-box {
  overflow: hidden;
  .el-input {
    width: 240px;
  }
  .el-select {
    width: 240px;
  }
  .search-btns {
    padding-left: 150px;
  }
  background-color: #f7f8fa;
}
.pagination {
  height: 60px;
}

.operation-box {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  padding-top: 16px;
}
</style>
